<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'informes' }">{{
                $t("informes")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("ventasPorAgencias") }}
            </li>
          </ol>
        </nav>
      </div>
      <CabeceraInformes
        v-if="vistaTicket==false"
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="data.length > 0">
          <template v-if="!vistaTicket">
            <div class="row justify-content-between div-export">
              <div class="col-md-12 text-left">
                <el-dropdown>
                  <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <a :href="urlExportPDF">
                      <el-dropdown-item class="text-danger">
                        <strong
                          ><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcel">
                      <el-dropdown-item class="text-success">
                        <strong
                          ><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div class="table-responsive" style="overflow: auto">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr>
                    <th>
                      <span
                        v-if="ordenarName"
                        @click="sortedArrayASC(1), (ordenarName = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("agencia") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(1), (ordenarName = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("agencia") }}
                      </span>
                    </th>
                     <th>
                      <span
                        v-if="ordenarTotal"
                        @click="sortedArrayASC(5), (ordenarTotal = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("total")  }} {{$t('deVentas')}}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(5), (ordenarTotal = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("total")  }} {{$t('deVentas')}}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarRecoger"
                        @click="sortedArrayASC(6), (ordenarRecoger = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("numeroPedidosRecoger") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(6), (ordenarRecoger = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("numeroPedidosRecoger") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarDomicilio"
                        @click="sortedArrayASC(7), (ordenarDomicilio = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("numeroPedidosDomicilio") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(7), (ordenarDomicilio = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("numeroPedidosDomicilio") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarBase"
                        @click="sortedArrayASC(3), (ordenarBase = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("base") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(3), (ordenarBase = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("base") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarImpuesto"
                        @click="sortedArrayASC(4), (ordenarImpuesto = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("impuesto") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(4), (ordenarImpuesto = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("impuesto") }}
                      </span>
                    </th>

                    <th>{{$t('comision')}}</th>
                    <th>{{$t('totalComision')}}</th>
                    <th>{{$t('totalSinComision')}}</th>

                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody v-if="data.length > 0">
                  <tr v-for="(obj, index) in data">
                    <td>{{ obj.name }}</td>
                    <td align="right">
                      <strong>{{ getTotal(index) | currency }}</strong>
                    </td>
                    <td align="right">{{ obj.numRecoger }}</td>
                    <td align="right">{{ obj.numDomicilio }}</td>
                    <td align="right">{{ getBase(index) | currency }}</td>
                    <td align="right">{{ getImpuesto(index) | currency }}</td>
                    <td align="right">{{ obj.comision }} %</td>
                    <td align="right">
                      {{ ((getTotal(index) * obj.comision) / 100) | currency }}
                    </td>
                    <td align="right">
                      {{ getTotal(index) - ((getTotal(index) * obj.comision) / 100)  | currency }}
                    </td>
                    <td align="center">
                      <span class="btn-link btn">
                        <i
                          @click="openModal(index)"
                          v-tooltip.top-center="'Desglose'"
                          class="fa fa-info-circle"
                        >
                        </i>
                      </span>
                      <span class="btn-link btn">
                        <i
                          @click="getTicketsAgencia(obj.idCode)"
                          class="fas fa-arrow-circle-right"
                          style="cursor: pointer"
                          v-tooltip.top-center="
                            $i18n.t('verTicketsDeEsaAgencia')
                          "
                        >
                        </i>
                      </span>
                    </td>
                  </tr>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalTotal | currency }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalRecoger }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalDomicilio }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalBase | currency }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalImpuesto | currency }}</strong>
                    </td>

                    <td></td>
                    <td align="right">
                      <strong>{{ getTotalComision | currency }}</strong>
                    </td>
                    <td align="right">
                      <strong>{{ getTotalTotalSinComision | currency }}</strong>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr></tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-else>
            <div class="col-md-3">
              <button @click="vistaTicket = false" class="btn btn-primary">
                <i class="fas fa-arrow-circle-left"></i>
                {{ $t("volverALaLista") }}
              </button>
            </div>
            <div class="col-md-12">
              <template v-for="ticket in listTickets">
                <ticket :ticket="ticket"></ticket>
              </template>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayEstadisticasDeAgenciaEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>

    <modal
      name="desgloseModal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4>{{ $t("desglosesImpuestosAgencia") }}</h4>
        </div>
        <div class="modal-body">
          <template v-if="listIva.length > 0">
            <div class="table-responsive" style="overflow: auto">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ $t("tipo") }}</th>
                    <th>{{ $t("base") }}</th>
                    <th>{{ $t("impuesto") }}</th>
                    <th>{{ $t("total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in listIva" v-if="listIva.length > 0">
                    <td>{{ i.iva }}</td>
                    <td align="right">{{ i.Bases | currency }}</td>
                    <td align="right">{{ i.Impuestos | currency }}</td>
                    <td align="right">{{ i.Totales | currency }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr></tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-else>
            <table class="table table-bordered table-striped">
              <tbody>
                <tr>
                  <td class="alert alert-danger" align="center" colspan="4">
                    <strong>{{ $t("noExisteDesgloseImpuestos") }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i> {{$t('volver')}}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Datetime from "vue-datetime";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Ticket from "../../../Widgets/Ticket.vue";
import { mapState } from 'vuex';

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorAgencias"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Datetime]: Datetime,
    ticket: Ticket,
    CabeceraInformes
  },
  data() {
    return {
      loading: null,
      vistaTicket: false,
      listBusinesses: [],
      idBusiness: 0,
      dates: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      data: ["-"],
      listTpv: [],
      listIva: [],
      idTpv: -1,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),

      //ORDENAR
      ordenarName: 0,
      ordenarNumComensales: 0,
      ordenarBase: 0,
      ordenarTipo: 0,
      ordenarImpuesto: 0,
      ordenarTotal: 0,
      ordenarRecoger: 0,
      ordenarDomicilio: 0,

      respuesta: true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {

      let idTpvAMandar = "";

      if (this.idTpv == -1) {
          idTpvAMandar = 0;
      } else {
          idTpvAMandar = this.idTpv;
      }

      return (
        this.$store.getters.apiUrl +
          "/agencias/exportEstadisticasAgencias/PDF?idBusiness=" +
        this.idBusiness +
          "&idTpv=" +
        idTpvAMandar +
          "&from=" +
        moment(this.datefrom).startOf("day").unix() +
          "&to=" +
        moment(this.dateto).endOf("day").unix() +
          "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {

      let idTpvAMandar = "";
      
      if (this.idTpv == -1) {
          idTpvAMandar = 0;
      } else {
          idTpvAMandar = this.idTpv;
      }

      return (
        this.$store.getters.apiUrl +
          "/agencias/exportEstadisticasAgencias/Excel?idBusiness=" +
        this.idBusiness +
          "&idTpv=" +
        idTpvAMandar +
          "&from=" +
        moment(this.datefrom).startOf("day").unix() +
          "&to=" +
        moment(this.dateto).endOf("day").unix() +
          "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalTotal() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          if (ele.data) {
            ele.data.forEach(function (d) {
              total += d.Totales;
            });
          }
        });
      }
      return total;
    },
    getTotalComision() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          if (ele.data) {
            ele.data.forEach(function (d) {
              total += (d.Totales * ele.comision) / 100;
            });
          }
        });
      }
      return total;
    },
    getTotalTotalSinComision() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          if (ele.data) {
            ele.data.forEach(function (d) {
              total += d.Totales - (d.Totales * ele.comision) / 100;
            });
          }
        });
      }
      return total;
    },
    getTotalRecoger() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          total += ele.numRecoger;
        });
      }
      return total;
    },
    getTotalDomicilio() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          total += ele.numDomicilio;
        });
      }
      return total;
    },
    getTotalBase() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          if (ele.data) {
            ele.data.forEach(function (d) {
              total += d.Bases;
            });
          }
        });
      }
      return total;
    },
    getTotalImpuesto() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          if (ele.data) {
            ele.data.forEach(function (d) {
              total += d.Impuestos;
            });
          }
        });
      }
      return total;
    },
    getTotalComensales() {
      let total = 0;
      if (this.data.length > 0) {
        this.data.forEach(function (ele) {
          total += ele.totComensales;
        });
      }
      return total;
    },
  },
  methods: {
    cambioBusiness(idBusinessData, listTpv) {
        if (listTpv) {
            this.listTpv = listTpv;
        }

        this.loading = Loading.service({ text: "Cargando..." });
        this.idBusiness = idBusinessData;
        this.idTpv = -1;
        this.list = [];
        this.cambioTpv()
    },
    emitirConsulta() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.getEstadisticasAgencia();
    },
    cambioTpv(idTpvData, filtrar) {

        if (idTpvData != undefined) {
          this.idTpv = idTpvData;
        }
        
        this.emitirConsulta();
    },
    cambioHora(dates) {
        this.datefrom = dates[0];
        this.dateto = dates[1];
    },
    sortedArrayASC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarName = 1;

          function compareName(a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.data.sort(compareName);

        case 2:
          this.ordenarNumComensales = 1;

          function compareNumComensales(a, b) {
            if (a.numComensales < b.numComensales) return -1;
            if (a.numComensales > b.numComensales) return 1;
            return 0;
          }

          return this.data.sort(compareNumComensales);

        case 3:
          this.ordenarBase = 1;
          function compareBase(a, b) {
            if (a.data[0].Bases< b.data[0].Bases) return -1;
            if (a.data[0].Bases > b.data[0].Bases) return 1;
            return 0;
          }
          return this.data.sort(compareBase);

        case 4:
          this.ordenarImpuesto = 1;

          function compareImpuesto(a, b) {
            if (a.data[0].Impuestos < b.data[0].Impuestos) return -1;
            if (a.data[0].Impuestos > b.data[0].Impuestos) return 1;
            return 0;
          }

          return this.data.sort(compareImpuesto);

        case 5:
          this.ordenarTotal = 1;

          function compareTotal(a, b) {
            if (a.data[0].Totales < b.data[0].Totales) return -1;
            if (a.data[0].Totales > b.data[0].Totales) return 1;
            return 0;
          }

          return this.data.sort(compareTotal);

        case 6:
          this.ordenarRecoger = 1;

          function compareRecoger(a, b) {
            if (a.numRecoger < b.numRecoger) return -1;
            if (a.numRecoger > b.numRecoger) return 1;
            return 0;
          }

          return this.data.sort(compareRecoger);

        case 7:
          this.ordenarDomicilio = 1;

          function compareDomicilio(a, b) {
            if (a.numDomicilio < b.numDomicilio) return -1;
            if (a.numDomicilio > b.numDomicilio) return 1;
            return 0;
          }

          return this.data.sort(compareDomicilio);
      }
    },
    sortedArrayDESC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarName = 0;

          function compareName(a, b) {
            if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.data.sort(compareName);

        case 2:
          this.ordenarNumComensales = 0;

          function compareNumComensales(a, b) {
            if (a.numComensales > b.numComensales) return -1;
            if (a.numComensales < b.numComensales) return 1;
            return 0;
          }

          return this.data.sort(compareNumComensales);

        case 3:
          this.ordenarBase = 0;

          function compareBase(a, b) {
            if (a.data[0].Bases > b.data[0].Bases) return -1;
            if (a.data[0].Bases < b.data[0].Bases) return 1;
            return 0;
          }

          return this.data.sort(compareBase);

        case 4:
          this.ordenarImpuesto = 0;

          function compareImpuesto(a, b) {
            if (a.data[0].Impuestos > b.data[0].Impuestos) return -1;
            if (a.data[0].Impuestos < b.data[0].Impuestos) return 1;
            return 0;
          }

          return this.data.sort(compareImpuesto);

        case 5:
          this.ordenarTotal = 0;

          function compareTotal(a, b) {
            if (a.data[0].Totales > b.data[0].Totales) return -1;
            if (a.data[0].Totales < b.data[0].Totales) return 1;
            return 0;
          }

          return this.data.sort(compareTotal);

        case 6:
          this.ordenarRecoger = 0;

          function compareRecoger(a, b) {
            if (a.numRecoger > b.numRecoger) return -1;
            if (a.numRecoger < b.numRecoger) return 1;
            return 0;
          }

          return this.data.sort(compareRecoger);

        case 7:
          this.ordenarDomicilio = 0;

          function compareDomicilio(a, b) {
            if (a.numDomicilio > b.numDomicilio) return -1;
            if (a.numDomicilio < b.numDomicilio) return 1;
            return 0;
          }

          return this.data.sort(compareDomicilio);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.getTpvs();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTpvs() {
      if (this.idBusiness.length > 0) {
        this.listTpv = [];

        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function (response) {
            if (response.data.response) {

              for (let i = 0; i < response.data.result.length; i++) {
                let tpv = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };
                vm.listTpv.push(tpv);
                vm.idTpv = -1;
              }

              vm.getEstadisticasAgencia();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    openModal(indice) {
      this.index = indice;

      let vm = this;

      vm.getIva(this.index);

      // if(this.listIva.length>0){
      this.$modal.show("desgloseModal");
      // }else{
      //Modal no hay desgloses?
      // }
    },
    cerrarModal() {
      this.indice = 0;
      this.index = 0;

      this.$modal.hide("desgloseModal");
      let vm = this;
      this.listIva = [];
    },
    getIva(index) {
      let vm = this;
      if (this.data[index].data) {
        this.data[index].data.forEach(function (d) {
          if (d.Totales != 0) {
            vm.listIva.push(d);
          }
        });
      }
    },

    getTotalSinComision(index, obj) {
      let total = 0;
      if (this.data[index].data) {
        this.data[index].data.forEach((d) => {
          total += d.Totales - (d.Totales * obj.comision) / 100;
        });
      }
      return total;
    },
    getTotal(index) {
      let total = 0;
      if (this.data[index].data) {
        this.data[index].data.forEach(function (d) {
          total += d.Totales;
        });
      }
      return total;
    },
    getBase(index) {
      let total = 0;
      let vm = this;

      if (this.data[index].data) {
        this.data[index].data.forEach(function (d) {
          total += d.Bases;
        });
      }

      return total;
    },
    getImpuesto(index) {
      let total = 0;
      let vm = this;
      if (this.data[index].data) {
        this.data[index].data.forEach(function (d) {
          total += d.Impuestos;
        });
      }
      return total;
    },

    getEstadisticasAgencia() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: 'Ups',
          text: "Seleccione una fecha de inicio y una fecha de fin.",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        vm.loading.close();

      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: 'Ups',
            text: "La fecha de inicio no puede ser posterior a la de fin.",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          vm.loading.close();

        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          let idTpvAMandar = "";

          if (this.idTpv == -1) {
              idTpvAMandar = 0;
          } else {
              idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: idTpvAMandar,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "agencias/getEstadisticasAgencias",
              config
            )
            .then(function (response) {

              if (response.data.response) {
                vm.data = response.data.result;
                vm.respuesta = true;
                vm.vistaTicket = false;
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                  swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                  });
                  vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t('atencion'),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }

              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    getTicketsAgencia(idCode) {

      if (this.idBusiness !== 0) {

        let idTpvAMandar = "";
        
        if (this.idTpv == -1) {
            idTpvAMandar = 0;
        } else {
            idTpvAMandar = this.idTpv;
        }

        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            idCode: idCode,
            idTpv: idTpvAMandar,
            from: moment(this.datefrom).startOf("day").unix(),
            to: moment(this.dateto).endOf("day").unix(),
          },

          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "agencias/getTicketsByIdAgencia",
            config
          )
          .then(function (response) {
            console.log(response);

            if (response.data.response) {
              vm.listTickets = response.data.result.tickets;
              vm.vistaTicket = true;
            } else {
              swal({
                title: vm.$t('atencion'),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      } else if (this.listBusinesses.length === 2) {

        let idTpvAMandar = "";

        if (this.idTpv == -1) {
            idTpvAMandar = 0;
        } else {
            idTpvAMandar = this.idTpv;
        }

        var config = {
          params: {
            idBusiness: this.listBusinesses[1]["id"],
            jwt: this.$store.getters.jwt,
            idCode: idCode,
            idTpv: idTpvAMandar,
            from: moment(this.datefrom).startOf("day").unix(),
            to: moment(this.dateto).endOf("day").unix(),
          },

          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "agencias/getTicketsByIdAgencia",
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.listTickets = response.data.result.tickets;
              vm.vistaTicket = true;
            } else {
              swal({
                title: vm.$t('atencion'),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        swal({
          title: this.$t('atencion'),
          text: this.$t('seleccioneUnNegocioParaVerLosTickets'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/EstadisticaAgencia.vue